import {AfterViewInit, Component, HostListener, Injectable, OnInit, ViewChild} from '@angular/core';
import {Location} from "@angular/common";
import {
  ActivatedRoute,
  ActivatedRouteSnapshot,
  CanDeactivate,
  Router,
  RouterStateSnapshot,
  UrlTree
} from "@angular/router";
import * as locale from "../../locale/calendar-ptbr";
import {BuscarContatoComponent} from "../../componentes/buscar-contato/buscar-contato.component";
import {ListaDePedidosComponent} from "../lista-de-pedidos/lista-de-pedidos.component";
import {PedidoLocalService} from "../../services/pedido-local.service";
import {ConstantsService} from "../../fidelidade/ConstantsService";
import {NgForm} from "@angular/forms";
import {PedidosService} from "../../services/pedidos.service";
import {PedidoLoja} from "../objetos/PedidoLoja";
import {BrindeService} from "../../services/brinde.service";
import {TelaAdicionarBrindeComponent} from "../tela-adicionar-brinde/tela-adicionar-brinde.component";
import {TelaResgateCashbackComponent} from "../tela-resgate-cashback/tela-resgate-cashback.component";
import {AutorizacaoService} from "../../services/autorizacao.service";
import {ContatosService} from "../../services/contatos.service";
import {TelaAdicionarProdutoComponent} from "../tela-adicionar-produto/tela-adicionar-produto.component";
import {TelaMesaEscolhidaComponent} from "../tela-mesa-escolhida/tela-mesa-escolhida.component";
import {TelaExpandidaComponent} from "../TelaExpandida";
import {DTOEmpresa} from "../objetos/DTOEmpresa";
import {DataHoraUtils} from "../../lib/DataHoraUtils";
import {ComandaService} from "../../services/comanda.service";
import { CartaoClienteService } from '../../services/cartao-cliente.service';

@Component({
  selector: 'app-tela-novo-pedido',
  templateUrl: './tela-novo-pedido.component.html',
  styleUrls: ['./tela-novo-pedido.component.scss']
})
export class TelaNovoPedidoComponent extends TelaExpandidaComponent implements OnInit, AfterViewInit {
  @ViewChild('frm') frm: NgForm;
  @ViewChild('telaMesaEscolhida') telaMesaEscolhida: TelaMesaEscolhidaComponent;
  @ViewChild('buscarContato', {static: false}) buscarContato: BuscarContatoComponent;
  @ViewChild('listaDePedidos') listaDePedidos: ListaDePedidosComponent;
  @ViewChild('telaAdicionarBrinde') telaAdicionarBrinde: TelaAdicionarBrindeComponent;
  @ViewChild('telaResgateCashback') telaResgateCashback: TelaResgateCashbackComponent;
  @ViewChild('telaAdicionarProduto', { static: false }) telaAdicionarProduto: TelaAdicionarProdutoComponent;

  contato: any = {};
  informarCpf: any;
  informarCnpj: any;
  cnpjObrigatorio: boolean;
  informarDataNascimento: boolean;
  public buttonCount = 5;
  public info = true;
  public type: 'numeric' | 'input' = 'numeric';
  public pageSizes = false;
  public previousNext = true;
  public editandoProduto = false;
  public adicionandoProduto = false;
  public adicionandoBrinde = false;
  public nomeContato = '';
  public telefone = '';
  ptBr: any;

  public pedido: PedidoLoja = new PedidoLoja()
  private urlRetorno: any;
  msgErro: string;
  estaNoIframe: boolean;
  tituloPagina: string;
  codigoPedido: any;
  modoEdicao: boolean;
  bloqueado: any;
  empresa: any;
  devePreencherContato = true;
  pedidoDeMesa = false;
  desktop = false;
  telefoneNaoIdentificado = '+5500000000000';
  BALCAO = 'balcao';
  public comanda: any;
  public cartaoCliente: any;
  tiposDocumento = [
    { id: 'cpf', nome: 'CPF' },
    { id: 'cnpj', nome: 'CNPJ' }
  ];
  documentoSelecionado: any = this.tiposDocumento[0];
  constructor(private router: Router, private activatedRoute: ActivatedRoute, private _location: Location,
              private brindeService: BrindeService, private autorizacaoService: AutorizacaoService,
              public contatosService: ContatosService,
              private pedidoLocalService: PedidoLocalService, private constantsService: ConstantsService,
              private pedidosService: PedidosService, private comandaService: ComandaService,
              private cartaoClienteService: CartaoClienteService) {
    super();
    let state = window.history.state;

    if( state.contato )
      this.contato = state.contato;
    this.pedido.contato = this.contato;
    this.constantsService.campoCpf$.subscribe( data => this.informarCpf = data);
    this.constantsService.campoCnpj$.subscribe( campo => {
      this.informarCnpj  = campo;
    });
    this.constantsService.campoDataNascimento$.subscribe( campoDataNascimento => {
      this.informarDataNascimento = campoDataNascimento
    });

    this.desktop = window.innerWidth >= 1024;
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.desktop = window.innerWidth >= 1024;
  }

  private setContato() {
    if(this.pedido.balcao) {
      this.pedidoLocalService.salveUrlAtual(this.BALCAO, this.router.url, window.history.state);
      return;
    }

    if (this.nomeContato && this.telefone) {
      const { codigoPais, telefone } = this.extraiCodigoPaisETelefone(this.telefone);
      this.contato.codigoPais = codigoPais;
      this.contato.telefone = telefone;
      this.contato.nome = this.nomeContato;
    }

    this.pedido.limpeTrocas();
    if(this.contato.dataNascimento)
      this.contato.dataNascimento = DataHoraUtils.obtenhaDataDaString(this.contato.dataNascimento);

    if(this.contato.cartoes && this.contato.cartoes.length){
      if(this.pedido.integracao ) {
        this.pedido.integracao.cartao =
          this.contato.cartoes.find(cartao => cartao.plano.id ===     this.empresa.integracaoPedidoFidelidade.plano.id);

      }
      this.pedido.setTrocas();
      this.carregueBrindes();
    }

    this.pedidoLocalService.salveUrlAtual(this.telefone, this.router.url, window.history.state);
  }

  carregueBrindes(){
    for(let i = 0 ; i <  this.pedido.trocas.length; i++){
      let troca = this.pedido.trocas[i];
      this.brindeService.listeDoPlano(troca.cartao.plano).then( (brindes) => {
        troca.brindes = brindes || [];
      })
    }
  }

  ngOnInit() {
    this.ptBr = locale.ptBR;

    this.constantsService.empresa$.subscribe( (empresa) => {
      if( !empresa ) return;

      this.empresa = empresa;
      this.pedido.dtoEmpresa = new DTOEmpresa(empresa);

      setTimeout(() => {
        if(this.pedido.dtoEmpresa && this.pedido.dtoEmpresa.ecommerce)
          this.telaAdicionarProduto.buscarNoServer = true;
      }, 10)

    });

    this.autorizacaoService.estaLogado().then( (resposta: any) => {
      this.bloqueado = resposta.bloqueado;
      if (!resposta.logado)
        this.redirecioneTelaLogin();

    });
  }

  contatoFoiBuscado({contato: contato, codigoPais: codigoPais, telefone: telefone}: any) {
    if ( contato && contato.id) {
      this.contato = contato
      this.nomeContato = contato.nome
      this.telefone = contato.codigoPais + contato.telefone

      if(this.pedido) this.pedido.contato = this.contato;

      this.setContato();
      this.pedidoLocalService.salvePedido(this.pedido);
    }
  }

  onSubmit() {

  }

  voltar() {
    if( this.adicionandoProduto  ) {
      this.adicionandoProduto = false;
      return;
    }

    if( this.editandoProduto  ) {
      this.editandoProduto = false;
      return;
    }

    if( this.adicionandoBrinde ) {
      this.adicionandoBrinde = false;
      return;
    }

    if((this.pedido && this.pedido.itens.length === 0) || this.pedido.id)
      this.pedidoLocalService.removaPedido(this.telefone);
    else
      this.pedidoLocalService.removaUrlSalva(this.telefone);

    if(this.urlRetorno)
      this.router.navigateByUrl(this.urlRetorno).then( () => {})
    else
      this._location.back();
  }



  exibaTelaAdicionarBrinde(resgate: any) {
    this.adicionandoBrinde = true;
    this.telaAdicionarBrinde.exibaResgate(resgate)
  }

  canceleAdicionarBrinde() {
    this.adicionandoBrinde = false;
  }

  public obtenhaTelefone() {
    if( this.telefone ) {
      return this.telefone;
    }

    return this.buscarContato.obtenhaTelefone();
  }

  salvePedido() {
    if( this.buscarContato && this.buscarContato.obtenhaTelefone()) {
      this.pedido.contato.telefone = this.buscarContato.obtenhaTelefone();

      if(this.buscarContato.contato && this.buscarContato.contato.nome)
        this.contato.nome = this.buscarContato.contato.nome;

    }

    this.pedidoLocalService.salvePedido(this.pedido);
  }

  ngAfterViewInit(): void {
    this.constantsService.empresa$.subscribe( (empresa: any) => {
      if(empresa && empresa.id){
        this.empresa = empresa;
        this.pedido.integracao  = this.empresa.integracaoPedidoFidelidade;

        this.activatedRoute.queryParams.subscribe(async (queryParams: any) => {
          this.urlRetorno = queryParams.urlRetorno;
          this.nomeContato = queryParams.nome;
          this.telefone = queryParams.tel;

          const idMesa = queryParams.idm,
            idComanda = queryParams.idc,
            idCartaoConsumo = queryParams.idcc,
            balcao = queryParams.bal != null,
            codigoPedido = this.activatedRoute.snapshot.params.codigo,
            copiar =  this.activatedRoute.snapshot.routeConfig.path.indexOf('copiar') >= 0,
            novoPedido: boolean = copiar || !codigoPedido;

          this.tituloPagina = novoPedido ? 'Novo Pedido' : 'Editar Pedido';

          if(balcao){
            this.devePreencherContato = false;
            this.pedido.balcao =  true;
            this.pedido.pago = true;
          }

          if(idComanda) {
            this.comandaService.obtenhaComanda(idComanda)
              .then(comandaData => {
                this.comanda = comandaData;
                if(this.telaMesaEscolhida) {
                  this.telaMesaEscolhida.codigoComanda = this.comanda.id;
                }
              }).catch(err => {
                console.error("Erro ao buscar a comanda", err);
              });
          }

          this.setContato();
          this.modoEdicao = true;

          if(codigoPedido) {
            await this.carreguePeloCodigo(codigoPedido, copiar);
          } else {
            if( this.buscarContato ) this.buscarContato.exibaContato(this.contato);

            if( idMesa ) {
              this.pedidoDeMesa = true;
              this.devePreencherContato = (!this.empresa.pedidoMesaNaoIdentificado
                || (this.telefone !== undefined && this.telefone !== this.telefoneNaoIdentificado));

              if( !this.devePreencherContato ) {
                this.pedido.contato = this.contato = this.gereConsumidorNaoIdentificado();
                this.carreguePedidoDoLocalStorage();
                this.salvePedido();
              }

              if(idCartaoConsumo) {
                this.cartaoClienteService.obtenhaCartao(queryParams.idcc)
                  .then(cartao => {
                    this.cartaoCliente = cartao;
                    if(this.cartaoCliente && this.cartaoCliente.empresa) {
                      this.empresa = this.cartaoCliente.empresa;
                      this.pedido.dtoEmpresa = new DTOEmpresa(this.empresa);
                    }
                  });
              }

              this.listaDePedidos.exibaPedido(this.pedido);
            } else {
              this.setContato();
              this.carreguePedidoDoLocalStorage();
              this.listaDePedidos.exibaPedido(this.pedido);
            }
          }
        });
      }
    });
  }

  async carreguePeloCodigo(codigoPedido: string, copiar: boolean){
    let pedidoServer: any, contato: any, erroCarregar: string;

    if(!copiar)  {
      pedidoServer = await this.pedidosService.obtenhaPorCodigo(codigoPedido).catch((err) => {
        erroCarregar = err;
      });
      this.tituloPagina +=  ' #' + pedidoServer.codigo;
      this.codigoPedido = codigoPedido
    } else {
      pedidoServer = await this.pedidosService.validePedirNovamente(codigoPedido).catch((err) => {
        erroCarregar = err;
      });
    }

    if(pedidoServer) {
      if(!pedidoServer.balcao){
        contato = await     this.contatosService.obtenhaContato(
          pedidoServer.cliente.telefone ? pedidoServer.cliente.codigoPais + pedidoServer.cliente.telefone : null);
      } else {
        this.devePreencherContato = false;
      }

      this.pedido = this.pedidoLocalService.obtenhaPedidoLojaPeloPedidoServer(pedidoServer, copiar);

      if( contato ) {
        this.pedido.contato = this.contato = contato;
        this.nomeContato = contato.nome;
        this.telefone = contato.codigoPais + contato.telefone;

        this.setContato();
      }

      if( !contato && pedidoServer.cliente.naoIdentificado) {
        this.pedido.contato = this.contato = pedidoServer.cliente
        this.setContato();
      }

      if( pedidoServer.mesa ) {
        this.pedidoDeMesa = true;
        this.devePreencherContato = (!this.empresa.pedidoMesaNaoIdentificado
          || (this.telefone !== undefined && this.telefone !== '+5500000000000'));
        this.telaMesaEscolhida.carregueMesa(pedidoServer.mesa);
      }

      this.pedido.integracao = this.empresa.integracaoPedidoFidelidade;
      if(contato)
        this.buscarContato.exibaContato(this.contato);
      this.listaDePedidos.exibaPedido(this.pedido);
      await this.carregueProdutosDoCanalPedido();
      this.reapliqueProdutosDaListagemNoPedido();
      this.salvePedido();

    } else {
      alert('Pedido não foi carregado, tente de novo')
    }

  }

  async carregueProdutosDoCanalPedido() {
    if(!this.telaAdicionarProduto)
      return;

    const tipoCardapio = this.obtenhaTipoCardapioPedido();
    const tabelaDePrecosId = Number(this.pedido?.idTabelaDePrecosAplicada || 0) || null;
    const tabelaCarregadaId = Number(this.telaAdicionarProduto.tabelaDePrecosCarregada?.id || 0) || null;
    if(tipoCardapio && (this.telaAdicionarProduto.tipoDeCardapio !== tipoCardapio ||
      tabelaCarregadaId !== tabelaDePrecosId))
      await this.telaAdicionarProduto.carregueProdutos(tipoCardapio, tabelaDePrecosId);
  }

  obtenhaTipoCardapioPedido(): string {
    if(this.pedido?.mesa || this.pedidoDeMesa)
      return 'MESA';

    if(this.pedido?.balcao)
      return 'BALCAO';

    const origem = String(this.pedido?.origem || '').toLowerCase();
    if(origem === 'loja' || origem === 'multiloja' || origem === 'bot')
      return 'DELIVERY';

    if(origem === 'ifood')
      return 'IFOOD';

    if(origem === '99food')
      return '99FOOD';

    if(origem === 'keeta')
      return 'KEETA';

    return this.telaAdicionarProduto?.tipoDeCardapio || 'ADMIN';
  }

  reapliqueProdutosDaListagemNoPedido(produtos: any[] = null) {
    const produtosAtuais = produtos || this.telaAdicionarProduto?.produtos || [];
    if(!this.pedido?.itens?.length || !produtosAtuais.length)
      return;

    if(!this.pedido.idTabelaDePrecosAplicada &&
      !this.pedido.itens.some((item: any) => this.possuiTabelaPrecoAplicada(item)))
      return;

    let alterou = false;

    this.pedido.itens.forEach((item: any) => {
      const produtoAtual = produtosAtuais.find((produto: any) => Number(produto.id) === Number(item.produto?.id));
      if(!produtoAtual)
        return;

      item.produto = produtoAtual;
      if(item.produtoTamanho)
        item.produtoTamanho = this.obtenhaProdutoTamanhoAtual(produtoAtual, item.produtoTamanho);

      this.reapliqueSaboresDaListagemNoItem(item, produtosAtuais);
      item.atualizeTotal();
      alterou = true;
    });

    if(alterou) {
      this.pedido.calculeTotal();
      this.listaDePedidos?.refreshGrid();
      this.salvePedido();
    }
  }

  private possuiTabelaPrecoAplicada(alvo: any, profundidade = 0): boolean {
    if(!alvo || profundidade > 5)
      return false;

    if(Array.isArray(alvo))
      return alvo.some((item: any) => this.possuiTabelaPrecoAplicada(item, profundidade + 1));

    if(typeof alvo !== 'object')
      return false;

    if(alvo.tabelaDePrecosAplicada || alvo.tabelaPrecoAtacado || alvo.idTabelaDePrecosAplicada ||
      alvo.idTabelaPrecosAplicada || alvo.idsTabelasDePrecosAplicadas?.length)
      return true;

    const props = ['produto', 'produtoTamanho', 'sabores', 'adicionais', 'opcoes', 'opcoesDisponiveis'];
    if(props.some((prop: string) => this.possuiTabelaPrecoAplicada(alvo[prop], profundidade + 1)))
      return true;

    return Object.keys(alvo).some((prop: string) =>
      (prop.startsWith('campo') || prop.startsWith('lista')) &&
      this.possuiTabelaPrecoAplicada(alvo[prop], profundidade + 1)
    );
  }

  private reapliqueSaboresDaListagemNoItem(item: any, produtosAtuais: any[]) {
    if(!item?.sabores?.length)
      return;

    item.sabores.forEach((sabor: any) => {
      const idProdutoSabor = Number(sabor.produto?.id || sabor.produto || 0);
      const produtoSaborAtual = produtosAtuais.find((produto: any) => Number(produto.id) === idProdutoSabor);
      if(!produtoSaborAtual)
        return;

      const tamanhoAtual = this.obtenhaProdutoTamanhoAtual(
        produtoSaborAtual,
        item.produtoTamanho || sabor.produtoTamanho
      );

      sabor.produto = produtoSaborAtual.id;
      sabor.nome = produtoSaborAtual.nome;
      sabor.descricao = produtoSaborAtual.descricao;
      sabor.produtoTamanho = tamanhoAtual;
      sabor.preco = Number(tamanhoAtual?.preco || 0);
    });
  }

  private obtenhaProdutoTamanhoAtual(produto: any, produtoTamanho: any): any {
    if(!produtoTamanho || !produto?.tamanhos?.length)
      return produtoTamanho;

    return produto.tamanhos.find((tamanho: any) => {
      if(tamanho.id && produtoTamanho.id && Number(tamanho.id) === Number(produtoTamanho.id))
        return true;

      return tamanho.template?.id && produtoTamanho.template?.id &&
        Number(tamanho.template.id) === Number(produtoTamanho.template.id);
    }) || produtoTamanho;
  }

  private gereConsumidorNaoIdentificado() {
    return {
      telefone: '00000000000',
      codigoPais: '+55',
      nome: 'Consumidor não identificado',
      naoIdentificado: true
    };
  }

  valideTela() {
    delete  this.msgErro;

    if( this.devePreencherContato ) {
      if (!this.contato.telefone) {
        this.msgErro = 'Informe o telefone do contato'
        return false;
      }

      if (this.contato.codigoPais === '+55' && this.contato.telefone.length < 10) {
        this.msgErro = 'Informe um telefone completo com DDD'
        return false;
      }
    }

    if(!this.pedido || !this.pedido.itens || this.pedido.itens.length === 0) {
      this.msgErro = 'Selecione ao menos um produto antes de informar o Endereço de Entrega'
      return false;
    }

    if(this.frm.invalid){
      this.msgErro = 'Informe todos os campos antes de proseguir'
      return false;
    }

    return true;
  }

  configureEnderecoEntrega() {
    let queryParams: any = {}

    if(!this.pedido.balcao){
      this.contato.telefone = this.buscarContato.obtenhaTelefone();
      this.contato.codigoPais = this.buscarContato.obtenhaCodigoPais();
      if(this.buscarContato.contato && this.buscarContato.contato.nome)
        this.contato.nome = this.buscarContato.contato.nome;

      queryParams = {
        tel: this.contato.codigoPais + this.contato.telefone,
        nome: this.contato.nome,
        idm: this.telaMesaEscolhida.obtenhaIdMesa()
      }
    }

    if( !this.valideTela() )  return;

    this.salvePedido();

    if(this.telaMesaEscolhida.modoGarcomAtivo())
      queryParams.mg = true


    this.router.navigate([], {
      relativeTo: this.activatedRoute,
      queryParams: queryParams,
      replaceUrl: true,
      queryParamsHandling: 'merge',
    }).then( () => {
      let querParams: any = {
        idm: this.telaMesaEscolhida.obtenhaIdMesa(),
        urlRetorno: this.urlRetorno,
        modoEdicao: this.modoEdicao
      }

      if(this.telaMesaEscolhida.modoGarcomAtivo())
        queryParams.mg = true

      if(!this.pedido.balcao){
        querParams.telefone = this.contato.codigoPais + this.contato.telefone
        this.router.navigate(['/admin/pedidos/novo/endereco'],
          {queryParams: querParams}).then( () => {});
      } else {
        querParams.telefone =  this.BALCAO;
        this.router.navigate(['/admin/pedidos/novo/pagamento'],
          {queryParams: querParams}).then( () => {});
      }
    });
  }

  private carreguePedidoDoLocalStorage( ) {
    let objPedido;
    if( this.contato.telefone ) {
      objPedido = this.pedidoLocalService.obtenhaPedido(this.contato.codigoPais + this.contato.telefone);
    } else {
       if(this.pedido.balcao)
         objPedido = this.pedidoLocalService.obtenhaPedido(this.BALCAO);
    }

    //bug: depois editar um pedido salva com id no localstorage, pedido com id nao carregar ...
    if( objPedido && !objPedido.id)
        this.pedido = objPedido

  }

  salveBrinde(brindeResgatado: any) {
    if(brindeResgatado.brinde) {
      let itemPedido = {
        qtde: brindeResgatado.qtde,
        valorUnitario: 0,
        produto: { nome: brindeResgatado.brinde.nome, valorUnitario: 0},
        brinde: brindeResgatado.brinde ,
        cartao: { id: brindeResgatado.cartao.id },
        obtenhaDescricao: ( ) => {
          return brindeResgatado.brinde.nome;
        },
        obtenhaUnidade: () => {
           return 'x'
        }
      };
      this.pedido.itens.push(itemPedido)
    }
    this.salvePedido();
    this.listaDePedidos.refreshGrid();
    this.canceleAdicionarBrinde();
  }


  podeResgatarBrinde() {
    if(!this.pedido || !this.pedido.trocas) return false;

    return this.pedido.trocas.find( troca => troca.cartao.pontos > 0 && !troca.ehCashback);
  }

  private redirecioneTelaLogin() {
    this.router.navigateByUrl('/admin/login?t=' + window.location.pathname).then( () => {

    });
  }
  cliqueAdicionarProdutos() {
    this.adicionandoProduto = true;
    this.telaAdicionarProduto.novoItem();
  }

  editeItemPedido(dataItem: any) {
    this.telaAdicionarProduto.editeItem(dataItem.indice, dataItem.item)

    if(this.telaAdicionarProduto.produtoSelecionado){
      this.editandoProduto = true;
    } else {
      alert(String(`Produto não disponivel`))
    }


  }

  adicioneProduto(itemPedido: any) {
    this.listaDePedidos.adicione(itemPedido);
    this.salvePedido();
    this.adicionandoProduto = false;

  }

  atualizeProduto(dados: any){
    let indice = dados.indice,
      itemPedido: any = dados.item;

    this.listaDePedidos.atualize(indice , itemPedido );
    this.salvePedido();
    this.editandoProduto = false;
  }

  canceleAdicionar(event: any) {
    this.adicionandoProduto = false;
    this.editandoProduto = false;
  }

  verificarPedidoMesa() {
    if(this.devePreencherContato){
      this.contato.telefone = this.buscarContato.obtenhaTelefone();
      this.contato.codigoPais = this.buscarContato.obtenhaCodigoPais();
      if(this.buscarContato.contato && this.buscarContato.contato.nome)
        this.contato.nome = this.buscarContato.contato.nome;
    }


    if( !this.valideTela() ) {
      return;
    }

    this.salvePedido();

    let queryParams: any = {
        tel: this.contato.codigoPais + this.contato.telefone,
        nome: this.contato.nome,
        idm: this.telaMesaEscolhida.obtenhaIdMesa()
      };

    if(this.telaMesaEscolhida.modoGarcomAtivo())
      queryParams.mg = true

    if(this.activatedRoute.snapshot.queryParams.novaComanda)
      queryParams.novaComanda = true;

    this.router.navigate([], {
      relativeTo: this.activatedRoute,
      queryParams: queryParams,
      replaceUrl: true,
      queryParamsHandling: 'merge',
    }).then( () => {
        queryParams = { telefone: this.contato.codigoPais + this.contato.telefone,
        idm: this.telaMesaEscolhida.obtenhaIdMesa(),
        urlRetorno: this.urlRetorno,
        modoEdicao: this.modoEdicao};

      if(this.telaMesaEscolhida.modoGarcomAtivo())
        queryParams.mg = true;

      if(this.telaMesaEscolhida.obtenhaIdGarcom())
        queryParams.idg = this.telaMesaEscolhida.obtenhaIdGarcom();

      if(this.telaMesaEscolhida.obtenhaCodigoComanda())
         queryParams.idc =  this.telaMesaEscolhida.obtenhaCodigoComanda()

      if(this.activatedRoute.snapshot.queryParams.novaComanda)
        queryParams.novaComanda = true;

      if(this.activatedRoute.snapshot.queryParams.idcc)
        queryParams.idcc = this.activatedRoute.snapshot.queryParams.idcc;

      this.router.navigate(['/admin/pedidos/novo/confirmar'],
        {queryParams: queryParams}).then( () => {});
    });
  }

  identificarConsumidor() {
    this.devePreencherContato = true;
    this.pedido.contato = this.contato = {};
    this.salvePedido();
  }

  naoIdentificarConsumidor() {
    this.devePreencherContato = false;
    this.pedido.contato = this.contato = this.gereConsumidorNaoIdentificado()
    this.salvePedido();
  }

  private extraiCodigoPaisETelefone(telefoneCompleto: string) {
    return this.contatosService.extraiCodigoPaisETelefone(telefoneCompleto)
  }

  trocarTipoDocumento(valor: any){
    // Limpa o outro campo
    if(this.documentoSelecionado.id === 'cpf') {
      this.contato.cnpj = null;
    } else {
      this.contato.cpf = null;
    }
  }

}
